import React from 'react';
import * as styles from './Row.module.scss';
/**
 * Primary UI component for user interaction
 */
const Row = _ref => {
  let {
    valign,
    align,
    reversed,
    children,
    style,
    classname
  } = _ref;
  // @TODO:REMOVE

  const classes = [valign ? styles[`v${valign}`] : '', align ? styles[`a${align}`] : '', reversed ? styles.rootReversed : ''];
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${classname ? classname : ''} ${classes.join(' ')}`,
    style: style
  }, children);
};
export default Row;